import React from "react";

import { Global } from "@emotion/react";
import PropTypes from "prop-types";

import { NewselaGlobalLayoutV2 } from "@/base/NewselaGlobalLayoutV2";
import { globalStyleOverrideCss } from "@/base/NewselaGlobalLayoutV2/NewselaGlobalLayoutV2.styles";
import AdminContentSettingsProvider from "@/search/AdminContentSettingsContext/AdminContentSettingsContext";

const propTypes = {
  mainContents: PropTypes.node,
  hideHeader: PropTypes.bool,
};

const BaseLayout = ({ mainContents, hideHeader = false }) => {
  return (
    <AdminContentSettingsProvider>
      <Global styles={globalStyleOverrideCss} />
      <NewselaGlobalLayoutV2
        mainContents={mainContents}
        hideHeader={hideHeader}
      />
    </AdminContentSettingsProvider>
  );
};

BaseLayout.propTypes = propTypes;

export default BaseLayout;
